import { PrivilegePageQueryReq_PrivilegeViewType } from '@src/endpoints/services/graphQueryMgr.service'

export enum PrivilegesView {
  Used = 'Used',
  Unused = 'Unused',
  All = 'All'
}

export const PrivilegeTabs = {
  [PrivilegePageQueryReq_PrivilegeViewType.USED]: 'Used',
  [PrivilegePageQueryReq_PrivilegeViewType.UNUSED]: 'Unused',
  [PrivilegePageQueryReq_PrivilegeViewType.ALL]: 'All'
}
